<template>
  <div :class="$style.supervisor_profile">
    <div :class="$style.inner">
      <AtomsConsumerImage :src="imageUrl" :alt="name" :width="192" :height="192" />
      <div :class="$style.profile">
        <p :class="$style.belong_position">{{ belongName }} {{ positionName }}</p>
        <div>
          <h3 :class="$style.name">{{ name }}</h3>
          <p :class="$style.name_alphabet">{{ nameAlphabet }}</p>
        </div>
        <div :class="$style.profile_content" v-html="formattedDescription" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"
type Props = {
  imageUrl: string
  name: string
  nameAlphabet: string
  belongName: string
  positionName: string
  description: string
}
const props = defineProps<Props>()

const formattedDescription = computed(() => {
  const description = sanitizeHtmlContent(props.description)
  return description.replace(/<a href=/g, '<a target="_blank" href=').replace(/\n/g, "<br>")
})
</script>
<style module lang="scss">
.supervisor_profile {
  @include container-md;
  .inner {
    padding: 2rem;
    background-color: $tertiary-20;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
    @include md {
      flex-direction: row;
    }
    img {
      width: 12rem;
      height: 12rem;
      @include md {
        max-width: 30rem;
      }
    }
    .profile {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      @include md {
        align-items: flex-start;
      }
      .belong_position {
        font-size: $font-size-10;
        font-weight: bold;
      }
      .name {
        font-size: $font-size-14;
        text-align: center;
        font-weight: bold;
        @include md {
          text-align: left;
        }
      }
      .name_alphabet {
        text-align: center;
        font-size: $font-size-10;
        @include md {
          text-align: left;
        }
      }
      .profile_content {
        font-size: $font-size-12;
        :global(a) {
          color: $primary;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
